module.exports = __webpack_public_path__ + "media/images/chicago_02_tall-b0a9fa446fd1567ceaaa38f50804629e.jpg";